import React from 'react';
import {ErrorModal} from '../../../system/ErrorModal/ErrorModal';

export const CreateCheckoutSessionErrorModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <ErrorModal
      isOpen={isOpen}
      onClose={onClose}
      mascotUrl="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Ferror-mascot-1.png"
      additionalMascotUrl="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content%2Fcoupon-purchase%2Ferror-mascot-2.png"
      message={
        <>
          Oh no...
          <br />
          <br />
          Your purchase can't be processed now
        </>
      }
      additionalMeassage={
        <>
          Try again later
          <br /> or{' '}
          <a target="_blank" href="https://pulsoid.net/contact">
            contact us
          </a>{' '}
          to get help
        </>
      }
    />
  );
};
